/**
 * @generated SignedSource<<4dd4ccc1d2d76dc1a9db0c681fc432e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type MerchantStoreState = "INACTIVE" | "LIVE" | "RETIRED" | "UNKNOWN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type useMerchantStoreMutations_fields$data = {
  readonly banner: {
    readonly id: string;
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly lat: number | null | undefined;
  readonly lng: number | null | undefined;
  readonly logo: {
    readonly id: string;
    readonly url: string | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly oldId: string | null | undefined;
  readonly organizationId: string;
  readonly primaryColor: string | null | undefined;
  readonly secondaryColor: string | null | undefined;
  readonly state: MerchantStoreState | null | undefined;
  readonly websiteUrl: string | null | undefined;
  readonly " $fragmentType": "useMerchantStoreMutations_fields";
};
export type useMerchantStoreMutations_fields$key = {
  readonly " $data"?: useMerchantStoreMutations_fields$data;
  readonly " $fragmentSpreads": FragmentRefs<"useMerchantStoreMutations_fields">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useMerchantStoreMutations_fields",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oldId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "websiteUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lng",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "primaryColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "secondaryColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "organizationId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "logo",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "banner",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    }
  ],
  "type": "MerchantStore",
  "abstractKey": null
};
})();

(node as any).hash = "c52df75525105650b9264f64d1d04f2c";

export default node;
